import React from "react";
import { useParams } from "react-router";
import { Divider } from "antd";
import { useSelector } from "react-redux";
import "./AgreementDetails.less";
import { formatDate } from "../../lib/utils";

const renderRow = (label, value) => (
  <div className="agreement-details__row">
    <span className="agreement-details__row_label">{label}</span>
    <span className="agreement-details__row_value">{value}</span>
  </div>
);

const AgreementDetails = () => {
  const { agreementId } = useParams();
  const { agreements } = useSelector((state) => state.agreements);
  const agreement = agreements.find(({ id }) => String(id) === String(agreementId));
  const { agrStatus: statuses } = useSelector((state) => state.rtkDictionaries);
  const status = statuses?.find(({ id }) => String(id) === String(agreement?.agreementStatusId));

  return (
    <>
      <h1>Договоры аккаунта</h1>
      <Divider className="divider_thin" />
      <section className="agreement-details__container">
        <h2>Свойства договора</h2>
        {renderRow("Статус", status?.name)}
        {renderRow("Номер договора", agreement?.agreementNumber)}
        {renderRow(
          "Дата договора",
          agreement?.agreementDate ? formatDate.toDisplayFormat(agreement.agreementDate) : ""
        )}
        {renderRow(
          "Действителен с",
          agreement?.validFrom ? formatDate.toDisplayFormat(agreement.validFrom) : ""
        )}
        {renderRow(
          "Действителен по",
          agreement?.validTo ? formatDate.toDisplayFormat(agreement.validTo) : ""
        )}
      </section>
    </>
  );
};

export default AgreementDetails;
